import {UUID} from '../../../shared/types/uuid.type';
import { createAction, props } from '@ngrx/store';
import {ProductionInstance, ProductionInstancesStatus} from '../../../services/api/production-instances/production-instance.model';

export const loadVmixServers = createAction(
  '[VmixServers] Load Vmix Servers'
);

export const loadVmixServersSuccess = createAction(
  '[VmixServers] Load Vmix Servers Success',
  props<{ data: ProductionInstance[] }>()
);

export const productionInstanceUpdated = createAction(
  '[VmixServers] Update Production Instance Success',
  props<{ data: ProductionInstance }>()
);

export const productionInstanceDeleted = createAction(
  '[VmixServers] Delete Production Instance Success',
  props<{ id: UUID }>()
);

export const manyProductionInstancesStatusChanged = createAction(
  '[VmixServers] Many Production Instances Status Changed',
  props<{ ids: UUID[]; status: ProductionInstancesStatus }>()
);

export const loadVmixServersFailure = createAction(
  '[VmixServers] Load Vmix Servers Failure',
  props<{ error: any }>()
);

export const clearVmixServersState = createAction(
  '[VmixServers] Clear Vmix Servers State',
);
